export const actionTokenAllowsUserMentions = (attrs: Record<string, unknown> | null | undefined) =>
    String(attrs?.tag || '')
        .replace(/^!+/, '')
        .toLowerCase() === 'pay'
